<div class="centered">
    <img
        src="/assets/images/scritta_bilancio in cloud.png"
        width="175px"
        height="auto"
    />
</div>
